import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import rootReducer from "./slices";
import { suppressConsoleInProduction } from './common/utils/disableConsole';
import { AuthProvider } from './common/context/AuthContext';

suppressConsoleInProduction();
const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();

const store = configureStore({ 
  reducer: rootReducer, 
  devTools: true,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
  }) 
});

root.render(
  <Provider store={store}>
    <AuthProvider>
      <BrowserRouter  basename={process.env.PUBLIC_URL}>
        <QueryClientProvider client={queryClient}>
          <App/>
        </QueryClientProvider>
      </BrowserRouter>
    </AuthProvider>
  </Provider>
);

reportWebVitals();
